import { render, staticRenderFns } from "./ServiceComment2.vue?vue&type=template&id=713f33d8&scoped=true&"
import script from "./ServiceComment2.vue?vue&type=script&lang=ts&"
export * from "./ServiceComment2.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceComment2.vue?vue&type=style&index=0&id=713f33d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713f33d8",
  null
  
)

export default component.exports